import { ApolloProvider } from '@apollo/client'
import {
  createTheme,
  ThemeProvider as MaterialUIThemeProvider,
} from '@material-ui/core/styles'
import client from '@swarm/core/services/apollo'
import { RequestCacheProvider } from '@swarm/core/services/cache/useRequestCache'
import { AppContextProvider } from '@swarm/core/state/AppContext'
import { FeatureFlagsContextProvider } from '@swarm/core/state/FeatureFlagsContext'
import { FireworksProvider } from '@swarm/ui/presentational/Fireworks'
import RouteNotFound from '@swarm/ui/presentational/RouteNotFound'
import { SnackbarProvider } from '@swarm/ui/swarm/Snackbar'
import theme from '@swarm/ui/theme'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Redirect, Route, BrowserRouter as Router } from 'react-router-dom'
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components/macro'
import { QueryParamProvider } from 'use-query-params'

import StakingPage from 'src/pages/Staking'
import { ROUTES } from 'src/routes'

const queryClient = new QueryClient()

function App() {
  return (
    <AppContextProvider>
      <QueryClientProvider client={queryClient}>
        <ApolloProvider client={client}>
          <RequestCacheProvider>
            <MaterialUIThemeProvider
              theme={createTheme({
                ...(theme as Record<string, unknown>),
                breakpoints: {
                  values: {
                    xs: 0,
                    sm: 640,
                    md: 832,
                    lg: 1024,
                    xl: 1920,
                  },
                },
              })}
            >
              <StyledComponentsThemeProvider theme={theme}>
                <SnackbarProvider>
                  <FireworksProvider>
                    <Router>
                      <QueryParamProvider ReactRouterRoute={Route}>
                        <FeatureFlagsContextProvider>
                          <Route
                            exact
                            path={ROUTES.HOMEPAGE}
                            component={() => <Redirect to={ROUTES.STAKING} />}
                          />
                          <Route
                            exact
                            path={[ROUTES.STAKING, ROUTES.STAKING_CATEGORY]}
                            component={StakingPage}
                          />
                          <Route path="*">
                            <RouteNotFound appRoutes={ROUTES} />
                          </Route>
                        </FeatureFlagsContextProvider>
                      </QueryParamProvider>
                    </Router>
                  </FireworksProvider>
                </SnackbarProvider>
              </StyledComponentsThemeProvider>
            </MaterialUIThemeProvider>
          </RequestCacheProvider>
        </ApolloProvider>
      </QueryClientProvider>
    </AppContextProvider>
  )
}

export default App
